export const queryKeys = {
  COMPANY_CONFIG_BOOKING_DELAY: 'COMPANY_CONFIG_BOOKING_DELAY',
  COMPANY_CONFIG_DOCUMENT_TEMPLATE_FORMAT: 'COMPANY_CONFIG_DOCUMENT_TEMPLATE_FORMAT'
};
